import React from 'react';
import CustomDialog from 'components/CustomDialog';
import AboutSection1 from './AboutSection1';
import AboutSection2 from './AboutSection2';

const About = () => (
    <CustomDialog title={'About KwadHub'}>
        <AboutSection1 />
        <AboutSection2 />
    </CustomDialog>
);
export default About;
